module.exports = __webpack_public_path__ + "img/error-pose.8915719b.svg";